import sourceOneRestRequest from "./SourceOneRestRequest";

//Takes the "props" found in a block component, pass key values based on type
export default function updateServerSession(props, key_vals) {
   const rootID = props.headlist.at(-1); //Last item on the headlist is your root
   const sessionID = props.flatDoc[rootID].session;

   sourceOneRestRequest({
      query_type: "app_session_set_state",
      session_id: sessionID,
      block_id: props.block.id,
      key_value_pairs: key_vals,
   })
      .then(() => {
         //dependents are held on the block, so this parts easy
         sourceOneRestRequest({
            query_type: "app_blocks_session",
            object: rootID.split("-root")[0],
            session_id: sessionID,
            block_ids: [...props.block.dependents, props.block.id],
         }).then((result) => {
            const compositeKeys = Object.entries(props.flatDoc)
               .filter((v) => result.find((r) => r.id === v[1].id))
               .map((k) => {
                  return k[0];
               });
            compositeKeys.forEach((c) => {
               props.setFlatDoc((n) => {
                  return {
                     ...n,
                     [c]: {
                        ...n[c],
                        data: {
                           ...result.find((d) => d.id === n[c].id).content,
                           name: result.find((d) => d.id === n[c].id).name,
                        },
                        react: {
                           ...n[c].react,
                           refresh: !n[c].react.refresh, //Refresh is a bool, just set it to not itself to trigger server to refresh data (as of 5/3, this is for data endpoint imp.)
                        },
                     },
                  };
               });
            });
         });
      })
      .catch((error) => console.error(error));

   return null;
}
